import messages from './messages.list';

window.__HPP_I18N_MESSAGES__ = messages;
